import { cleanTrackingUrl } from './urlHelpers.js';

$(function () {
    // Search Result Impressions (Product + Promotion)
    var searchInterface = document.getElementsByClassName('CoveoSearchInterface');

    if (searchInterface && searchInterface.length) {
        var root = document.querySelector('#' + searchInterface[0].id);
        Coveo.$$(root).on('deferredQuerySuccess',
            function (event, query) {
                if (query && query.results && query.results.results && query.results.results.length) {

                    // Search Result Product Impressions
                    var impressions = query.results.results.filter(function (result) {
                        return result.raw[Coveo.coveoFieldName('analyticsProductData')];
                    }).map(function (result, index) {
                        var data = JSON.parse(result.raw[Coveo.coveoFieldName('analyticsProductData')]);
                        data.position = index + 1;

                        return data;
                    });

                    dataLayer.push({
                        'ecommerce': {
                            'impressions': impressions
                        }
                    });

                    // Search Result Featured Product Impressions
                    var featuredProductImpressions = query.results.results.filter(function (result) {
                        return result.raw[Coveo.coveoFieldName('analyticsFeaturedProductData')];
                    }).map(function (result, index) {
                        return result.raw[Coveo.coveoFieldName('analyticsFeaturedProductData')];
                    });

                    dataLayer.push({
                        'ecommerce': {
                            'impressions': featuredProductImpressions
                        }
                    });
                }
            });
    }

    // Search Result Product Clicks
    window.productClickAnalytics = window.productClickAnalytics ||
        function (event) {
            if (event && event.button === 2) return;
            if (event.currentTarget.dataset.analyticsdata) {
                var productObj = JSON.parse(event.currentTarget.dataset.analyticsdata);

                if (productObj) {
                    if (event.currentTarget.href) {
                        productObj.url = cleanTrackingUrl(event.currentTarget.href);
                    }
                    dataLayer.push({
                        'event': 'productClick',
                        'ecommerce': {
                            'click': {
                                'actionField': { 'list': 'Search Results' },
                                'products': [productObj]
                            }
                        }
                    });
                }
            }
        };

    // Search Result Promotion Clicks
    window.promotionClickAnalytics = window.promotionClickAnalytics ||
        function (event) {
            if (event && event.button === 2) return;
            if (event.currentTarget.dataset.analyticsdata) {
                dataLayer.push({
                    'event': 'promotionClick',
                    'ecommerce': {
                        'promoClick': {
                            'promotions': [{
                                name: event.currentTarget.dataset.analyticsdata,
                                url: cleanTrackingUrl(event.currentTarget.href) || ''
                            }]
                        }
                    }
                });
            }
        };
});